<template lang="pug">
.container-fluid
  .container
    .row.align-items-center
      .col-3
        router-link(to="/")
          span.site-name {{ $t('property_list_page.rent_assessment_system') }}

      .col-4.margin-right
        .input-group(v-if="showSearch")
          .input-group-prepend
            span.input-group-text
              i.fas.fa-search
          input.form-control.pl-0(
            :placeholder="$t('property_list_page.enter_keyword')"
            @keyup.enter="submit",
            v-model="searchString"
          )
      .col(v-if="showSearch")
        button.search(href='#', @click='submit') {{ $t('property_list_page.search') }}
      .col
        b-dropdown.float-right(:text="fullName" right)
          b-dropdown-item(
            v-if="isSuperadmin"
            :to="{ name: 'AdminUserList' }"
          ) {{ $t('users_list.manage_users') }}
          b-dropdown-item(:to="{ name: 'ProfilePage' }") {{ $t('property_list_page.profile') }}
          b-dropdown-item(@click="resetSession") {{ $t('property_list_page.log_out') }}
        select.float-right(
          v-if="isTestingAccount"
          v-model="$i18n.locale"
        )
          option(v-for="(lang, i) in Object.keys($i18n.messages)" :key="`Lang${i}`" :value="lang") {{ lang }}
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { isEmpty } from 'lodash'

export default {
  data() {
    return {
      showSearch: false,
      searchString: this.$route.query.search || ''
    }
  },

  computed: {
    ...mapState(['currentUser']),

    fullName() {
      if (this.currentUser) {
        return `${this.currentUser.first_name} ${this.currentUser.last_name}`
      }
      return ''
    },

    isTestingAccount() {
      if (!isEmpty(this.currentUser)) {
        return this.currentUser.test_account
      } else {
        return false
      }
    },

    isSuperadmin() {
      if (!isEmpty(this.currentUser)) {
        return this.currentUser.role == 'superadmin'
      } else {
        return false        
      }
    }
  },

  watch: {
    $route() {
      this.setShowSearch()
      this.searchString = this.$route.query.search || ''
    }
  },

  mounted() {
    this.setShowSearch()
  },

  methods: {
    ...mapMutations(['FETCH_CURRENT_USER_FAILURE']),

    setShowSearch() {
      this.showSearch = (this.$route.name == 'PropertyList')
    },

    submit() {
      const params = this.$router.params
      const query = { ...this.$router.query, search: this.searchString }
      this.$router.push({ name: 'PropertyList', params, query })
    },

    resetSession() {
      localStorage.removeItem('AuthToken')
      localStorage.removeItem('userRole')
      this.FETCH_CURRENT_USER_FAILURE()
      this.$router.push({ name: 'LoginPage' })
    }
  }
}
</script>

<style lang="scss" scoped>
.container-fluid {
  background-image: linear-gradient(90deg, rgba(24, 172, 235, 0.98) 0%, #18a4eb 100%);

  a {
    white-space: nowrap;
  }
}

.search {
  background: transparent;
  border: none;
  color: #fff;
}

.margin-right {
  margin-right: -25px;
}

a:hover {
  text-decoration: none;
}

.row {
  height: 64px;
}

.logo {
  height: 36px;
  width: 32px;
}

.site-name {
  color: rgba(255, 255, 255, 0.9);
  font-size: 15px;
  font-weight: 700;
  white-space: nowrap;
}

.input-group {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;

  .input-group-text {
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.6);
  }

  .form-control {
    background: none;
    border: none;
    color: #fff;
    font-size: 13px;

    &::placeholder {
      color: rgba(255, 255, 255, 0.6);
    }

    &:focus {
      box-shadow: none;
    }
  }
}

::v-deep .dropdown {
  .dropdown-toggle {
    background: transparent !important;
    border: none;
    color: rgba(255, 255, 255, 0.9) !important;
    font-size: 14px;

    &:active,
    &:focus {
      background-color: transparent !important;
      box-shadow: none !important;
      color: rgba(255, 255, 255, 0.9) !important;
    }
  }
}

@media (max-width: 995px) {
  .site-name {
    font-size: 13px;
  }

  .logo {
    width: 28px;
  }
}

@media (max-width: 725px) {
  .site-name {
    font-size: 12px;
  }

  .logo {
    width: 25px;
  }
}

@media (max-width: 695px) {
  .site-name {
    font-size: 9px;
  }

  .logo {
    width: 20px;
  }
}
</style>
